import React from 'react';
import walkToUnlockImage from '../../../public/static/images/rat-race/walkToUnlock.png';
import yourRatCompanionImage from '../../../public/static/images/rat-race/yourRatCompanion.png';
import earnCheddarImage from '../../../public/static/images/rat-race/earnCheddar.png';
import useMobileCarousel from '../hooks/useMobileCarousel';
import styles from './index.module.scss';

const getAssetSrc = (asset) => asset?.src || asset;

const DISTANCE_ITEMS = [
  {
    key: 'goal',
    image: earnCheddarImage,
    alt: 'Your Daily Step Goal',
    title: 'Your Daily Step Goal',
    description:
      'Earn screen time by reaching your daily step goal to unlock your apps.',
  },
  {
    key: 'sidekick',
    image: yourRatCompanionImage,
    alt: 'Your Rat Sidekick',
    title: 'Your Rat Sidekick',
    description:
      'Your rat will be with you every step of the way - from hot girl walks to trips to the fridge.',
  },
  {
    key: 'cheddar',
    image: walkToUnlockImage,
    alt: 'Your Cheddar',
    title: 'Your Cheddar',
    description:
      'Every walk earns you Cheddar, our in-app currency. You can spend it on cute outfits and rest days.',
  },
];

function DistanceCard({ item, className, style }) {
  return (
    <div className={className} style={style}>
      <img
        className={styles.walkUnlockImage}
        src={getAssetSrc(item.image)}
        alt={item.alt}
      />
      <h3 className={styles.walkUnlockTitle}>{item.title}</h3>
      <p className={styles.walkUnlockDescription}>{item.description}</p>
    </div>
  );
}

export default function RatRaceDistance() {
  const { activeSlide, setActiveSlide, handleTouchStart, handleTouchEnd } =
    useMobileCarousel(DISTANCE_ITEMS.length);

  return (
    <section className={styles.distanceSection}>
      <div className={styles.distanceTitleWrap}>
        <h2 className={styles.distanceTitle}>
          Everything You Need
          <br />
          To Go The Distance.
        </h2>
      </div>
      <div className={styles.distanceInner}>
        <div className={styles.walkUnlockContainer}>
          {DISTANCE_ITEMS.map((item) => (
            <DistanceCard
              key={item.key}
              item={item}
              className={styles.walkUnlockCopy}
            />
          ))}
        </div>
        <div className={styles.distanceMobileCarousel}>
          <div
            className={styles.distanceMobileViewport}
            onTouchStart={handleTouchStart}
            onTouchEnd={handleTouchEnd}
          >
            <div
              className={styles.distanceMobileTrack}
              style={{ transform: `translateX(-${activeSlide * 100}%)` }}
            >
              {DISTANCE_ITEMS.map((item, index) => (
                <DistanceCard
                  key={item.key}
                  item={item}
                  className={styles.distanceMobileSlide}
                  style={{ opacity: index === activeSlide ? 1 : 0.4 }}
                />
              ))}
            </div>
          </div>
          <div className={styles.distanceMobileDots}>
            {DISTANCE_ITEMS.map((item, index) => (
              <button
                key={item.key}
                type="button"
                className={`${styles.distanceMobileDot} ${index === activeSlide ? styles.distanceMobileDotActive : ''
                  }`}
                onClick={() => setActiveSlide(index)}
                aria-label={`Show slide ${index + 1}`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
